import { mutatorAction } from "satcheljs";
import { IRestorableSchedulesByGroup } from "sh-models";
import { UserStore } from "sh-stores";

export default mutatorAction('SET_RESTORABLE_SCHEDULES_BY_GROUP', function setRestorableSchedulesByGroup(restorableSchedulesByGroup: IRestorableSchedulesByGroup[]) {
    UserStore().restorableSchedulesByGroup = restorableSchedulesByGroup || [];
});
